import reactCSS from 'reactcss';
export const styles = reactCSS({
  'default': {
    LogoContainer: {
      display: 'block'
    },
    LogoContainerFooter: {
      width: '15%',
      display: 'inline-block',
      margin: '10px auto 0'
    }
  }
});



// WEBPACK FOOTER //
// ./src/app/components/Global/Logo/Logo.style.js